import { render } from "./SurveyExpireWeb.vue?vue&type=template&id=822c90c0&scoped=true"
import script from "./SurveyExpireWeb.vue?vue&type=script&lang=js"
export * from "./SurveyExpireWeb.vue?vue&type=script&lang=js"

import "./SurveyExpireWeb.vue?vue&type=style&index=0&id=822c90c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822c90c0"]])

export default __exports__